var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.386,
    height: 19.386,
    viewBox: "0 0 19.386 19.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "organization-chart",
    d: "M15.924,3A1.077,1.077,0,0,1,17,4.077V8.385a1.077,1.077,0,0,1-1.077,1.077H13.77v2.154h4.308a1.077,1.077,0,0,1,1.077,1.077v3.231h2.154A1.077,1.077,0,0,1,22.386,17v4.308a1.077,1.077,0,0,1-1.077,1.077H14.847a1.077,1.077,0,0,1-1.077-1.077V17a1.077,1.077,0,0,1,1.077-1.077H17V13.77H8.385v2.154h2.154A1.077,1.077,0,0,1,11.616,17v4.308a1.077,1.077,0,0,1-1.077,1.077H4.077A1.077,1.077,0,0,1,3,21.309V17a1.077,1.077,0,0,1,1.077-1.077H6.231V12.693a1.077,1.077,0,0,1,1.077-1.077h4.308V9.462H9.462A1.077,1.077,0,0,1,8.385,8.385V4.077A1.077,1.077,0,0,1,9.462,3ZM9.462,18.078H5.154v2.154H9.462Zm10.77,0H15.924v2.154h4.308ZM14.847,5.154H10.539V7.308h4.308Z",
    transform: "translate(-3 -3)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationChart);
export default __webpack_public_path__ + "static/media/organization-chart.839b674798c8eaff2dac3fcb902f3c9b.svg";
export { ForwardRef as ReactComponent };